/**
 * Kratome — Recently viewed products
 * Stores visited product handles in localStorage (no server, no cookie
 * consent needed) and renders them into any [data-recently-viewed]
 * section via /products/{handle}.js.
 */
(function () {
  "use strict";

  var STORAGE_KEY = "kratome_recently_viewed";
  var MAX_ITEMS = 8;

  function getStored() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function trackCurrentProduct() {
    var el = document.querySelector("[data-current-product-handle]");
    if (!el) return;
    var handle = el.dataset.currentProductHandle;
    if (!handle) return;
    var list = getStored().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    list = list.slice(0, MAX_ITEMS);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function money(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || "en", {
      style: "currency",
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "EUR",
    });
  }

  function renderInto(container) {
    var excludeHandle = container.dataset.excludeHandle || "";
    var handles = getStored().filter(function (h) { return h !== excludeHandle; }).slice(0, parseInt(container.dataset.max || "4", 10));
    if (!handles.length) {
      container.closest("[data-recently-viewed-section]").style.display = "none";
      return;
    }
    Promise.all(
      handles.map(function (handle) {
        return fetch("/products/" + handle + ".js").then(function (r) { return (r.ok ? r.json() : null); }).catch(function () { return null; });
      })
    ).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) {
        container.closest("[data-recently-viewed-section]").style.display = "none";
        return;
      }
      var html = "";
      products.forEach(function (product) {
        html +=
          '<a href="' + product.url + '" class="product-card">' +
          '<div class="product-card__media">' + (product.featured_image ? '<img src="' + product.featured_image + '" alt="" loading="lazy">' : "") + "</div>" +
          '<p class="product-card__title">' + product.title + "</p>" +
          '<p class="product-card__price">' + money(product.price) + "</p>" +
          "</a>";
      });
      container.innerHTML = html;
    });
  }

  function init() {
    trackCurrentProduct();
    document.querySelectorAll("[data-recently-viewed]").forEach(renderInto);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
